import { LlmProvider } from '@/types/llm-provider';

// Brand colors from email template
export const COLORS = {
  primary: '#3c00ff',
  black: '#020203',
  white: '#ffffff',
  gray: '#f3f4f5',
  border: '#e0e0e1', // rgba(2,2,3,0.06) on white
  textMuted: '#808082', // rgba(2,2,3,0.5) on white
  green: '#16a34a',
  red: '#dc2626',
} as const;

// LLM provider colors from email CSS
export const LLM_COLORS: Record<LlmProvider, string> = {
  [LlmProvider.ChatGPT]: '#10a37f',
  [LlmProvider.Claude]: '#d97706',
  [LlmProvider.Gemini]: '#4285f4',
  [LlmProvider.Perplexity]: '#20808d',
  [LlmProvider.Grok]: '#1d9bf0',
  [LlmProvider.DeepSeek]: '#6366f1',
};

// PDF layout constants (A4: 210mm x 297mm)
export const LAYOUT = {
  pageWidth: 210,
  pageHeight: 297,
  margin: 25,
  contentWidth: 160, // 210 - 2*25
  lineHeight: 6,
  sectionGap: 12,
} as const;
